import { FC } from 'react';
import icon from './svg/warning-color.svg';

export const WarningColorIcon: FC = ({ ...props }) => <img src={icon} alt="warning color icon" {...props} />;
